import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import Confirm from "../../Common/Confirm";

import Api from "../../../../services/Api";

function DeleteStudentInvitesModal({
  onClose,
  filters,
  invites,
  organizationId,
  setConfirmModal,
}) {
  const [firstText, setFirstText] = useState("");
  const [secondText, setSecondText] = useState(null);

  const getSecondText = (otherInvites) => {
    return (
      <div className="text-2xl font-medium text-primary-blue">
        <p>
          You cannot delete the following
          {otherInvites.length > 1 ? " student invites" : " student invite"},
          since you did not send the initial
          {otherInvites.length > 1 ? " invites" : " invite"}.
        </p>
        <ul className="ml-4 py-4">
          {otherInvites.map((item, i) => (
            <li
              key={`${i}-${item}`}
              className="list-disc list-inside text-black"
            >
              <span>{item}</span>
            </li>
          ))}
        </ul>
        <p>You can contact the initial sender to delete these invites.</p>
      </div>
    );
  };

  useEffect(() => {
    const handlerDeleteInvites = async () => {
      const ownInvitesIds = invites?.map((invite) => invite.id) || [];
      const dataMutation = {
        organizationId,
        invitations: {
          filter: ownInvitesIds.length > 0 ? null : filters,
          ids: ownInvitesIds.length > 0 ? ownInvitesIds : null,
        },
      };

      const { deletedCount, nonDeletedInvitations } =
        await Api.deleteStudentInvites(dataMutation);

      setFirstText(
        `You have deleted ${deletedCount} student ${
          deletedCount === 1 ? "invite" : "invites"
        }`
      );
      if (nonDeletedInvitations.length > 0)
        setSecondText(getSecondText(nonDeletedInvitations));
      setConfirmModal(true);
    };

    handlerDeleteInvites();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invites, filters]);

  return (
    <div className="flex flex-col h-full">
      <Confirm
        onClick={onClose}
        firstText={firstText}
        secondText={secondText}
        buttonText="Go Back to Manage Invites"
      />
    </div>
  );
}

DeleteStudentInvitesModal.propTypes = {
  filters: PropTypes.shape(),
  organizationId: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  setConfirmModal: PropTypes.func.isRequired,
  invites: PropTypes.arrayOf(PropTypes.shape()),
};

export default DeleteStudentInvitesModal;
